import React from 'react'
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Home, Folder, FileText, LogOut, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { motion } from 'framer-motion';

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/auth');
  };

  const navItems = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/categories', icon: Folder, label: 'Categorie' },
    { path: '/notes', icon: FileText, label: 'Note' },
  ];

  // Aggiungi Admin solo se l'utente è admin
  if (user?.is_admin) {
    navItems.push({ path: '/admin', icon: Shield, label: 'Admin' });
  }

  const isActive = (path) => location.pathname === path;

  return (
    <div className="flex h-screen bg-background">
      {/* Desktop Sidebar */}
      <aside className="hidden md:flex flex-col w-64 border-r border-border bg-card p-6">
        <div className="mb-8">
          <h2 className="text-2xl font-bold tracking-tight">Memorandum</h2>
          <p className="text-sm text-muted-foreground mt-1">Gestione note</p>
        </div>

        <nav className="flex-1 space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <Button
                key={item.path}
                variant={isActive(item.path) ? 'default' : 'ghost'}
                className="w-full justify-start h-12 rounded-xl"
                onClick={() => navigate(item.path)}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <Icon className="w-5 h-5 mr-3" />
                {item.label}
              </Button>
            );
          })}
        </nav>

        <Button
          variant="outline"
          className="w-full justify-start h-12 rounded-xl text-destructive hover:text-destructive hover:bg-destructive/10"
          onClick={handleLogout}
          data-testid="logout-button"
        >
          <LogOut className="w-5 h-5 mr-3" />
          Esci
        </Button>
      </aside>

      {/* Main Content */}
      <main className="flex-1 flex flex-col overflow-hidden">
        <Outlet />
      </main>

      {/* Mobile Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 h-16 bg-white/80 backdrop-blur-lg border-t border-border flex items-center justify-around z-50 md:hidden">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center w-full h-full transition-colors ${
                active ? 'text-primary' : 'text-muted-foreground'
              }`}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              <Icon className="w-6 h-6" />
              <span className="text-xs mt-1">{item.label}</span>
            </button>
          );
        })}
        <button
          onClick={handleLogout}
          className="flex flex-col items-center justify-center w-full h-full text-destructive transition-colors"
          data-testid="mobile-logout-button"
        >
          <LogOut className="w-6 h-6" />
          <span className="text-xs mt-1">Esci</span>
        </button>
      </nav>
    </div>
  );
}